import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { ReactElement, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { IJsonObject } from "../api";
import { usePusher } from "../PusherContext";
import { DialerService } from "./";
import { Call } from "./Call";

interface IParams {
	number: string;
	leadId: string;
	onCallInitiated: (call: Call) => void;
	onCallStateChange: (call: Call) => void;
}

export const DialerCallButton = (props: IParams): ReactElement => {
	const [isCalling, setIsCalling] = useState<boolean>(false);
	const [validPhoneNumber, setValidPhoneNumber] = useState<boolean>(false);
	const [callId, setCallId] = useState<number | null>();
	const pusher = usePusher();

	const channel = pusher.subscribe("hrlr-call-status");

	const dialerService = new DialerService();

	/**
	 * Validate a phone number is in the E.164 format.
	 *
	 * @param phoneNumber
	 */
	const validateNumber = (phoneNumber: string) => {
		const re = new RegExp(/^\+[1-9]\d{1,14}$/);
		phoneNumber = phoneNumber
			.replace(/\s/g, "")
			.replace(new RegExp("-", "gi"), "")
			.replace(new RegExp("\\(", "gi"), "")
			.replace(new RegExp("\\)", "gi"), "");

		if (!phoneNumber.startsWith("+")) {
			phoneNumber = `+${phoneNumber}`;
		}

		setValidPhoneNumber(re.test(phoneNumber));
	};

	useEffect(() => {
		validateNumber(props.number);
	}, [props.number]);

	useEffect(() => {
		channel.bind(`call-status-${callId}`, (data: IJsonObject) => {
			const newCall = Call.fromJson(JSON.parse(data.message));
			if (newCall.state === "hangup") {
				setIsCalling(false);
			}

			props.onCallStateChange(newCall);
		});
	}, [callId]);

	const callLead = async () => {
		const newCall = await dialerService.call(props.leadId, props.number);

		if (newCall) {
			setCallId(newCall.daialerCallId);
			setIsCalling(true);
			props.onCallInitiated(newCall);
		}
	};

	return (
		<>
			<Button
				onClick={callLead}
				disabled={!validPhoneNumber || isCalling}
				style={{ width: 200 }}
			>
				<FontAwesomeIcon icon={faPhone} className="mr-2" />
				Call {props.number}
			</Button>
			{!validPhoneNumber ? (
				<div className="mt-2">
					<strong>
						Please update the phone field to a valid format, for
						example +19027551884
					</strong>
				</div>
			) : null}
		</>
	);
};
